import { useState } from "react";
import { useDispatch } from "react-redux";
import forgotPasswordSchema from "../../validation/forgotPasswordSchema";
import { authActions } from "../../_store";
import { showToastNotification } from "../../components/common/ui/NotificationModal/ToastNotication";
import CustomLoader from "../../components/common/ui/Loader";
import { TextInput } from "../../components/common/ui/Inputs";
import Logo from "../../assets/Broward-Partnerships-for-kids-logo.png";
import { useNavigate } from "react-router-dom";
import { history } from "../../_helpers";
import Button from "../../components/common/ui/Button";

function AdminForgotPassword() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState();
  const [errorMessage, setErrorMessage] = useState({});
  const [submit, setSubmit] = useState(false);

  // Forgot Password - submit function
  const handleSubmit = async (event) => {
    event.preventDefault();

    setErrorMessage({});
    setSubmit(true);
    const { error } = forgotPasswordSchema({ email });
    if (error?.details) {
      setSubmit(false);
      error?.details?.map((e) => {
        const { path } = e;
        setErrorMessage((prev) => ({
          ...prev,
          [path[0]]: e?.message,
        }));
      });
      return;
    }

    dispatch(authActions?.forgotPassword({ email: email, type: "admin" }))
      .then((result) => {
        setSubmit(false);
        if (result?.payload?.status === 1) {
          showToastNotification(result?.payload?.message, "success");
          handleReset();
          dispatch(authActions.clearForgotPasswordResponse());
          // history?.navigate("/Admin/Committee", {
          //   state: { committeeID: 0 },
          // });
        } else {
          showToastNotification(result?.error?.message, "error");
        }
      })
      .catch((err) => {
        showToastNotification("Failed to create committee", "error");
        setSubmit(false);
      });
  };

  // Handle reset action
  const handleReset = () => {
    setErrorMessage({});
    setEmail("");
  };

  // Function for navigate login page
  const handleClickLogin = () => {
    history?.navigate("/Admin/login");
  };

  // Function for navigate regsiter page
  const handleSignUp = () => {
    navigate("/register");
  };

  const handleForgotPasswordEmail = (e) => {
    const { name, value } = e?.target;
    if (name === "email") {
      // const regex = /^[a-zA-Z0-9.@_\s]*$/;
      const regex = /^[a-zA-Z0-9.@!#$*+-_\s]*$/;
      if (!regex.test(value)) return;
      if (value.trim() === "" && value !== "") return;
    }
    setEmail(e?.target?.value);
  };

  if (loader) return <CustomLoader />;

  return (
    <>
      <section className="sign-in-section admin-login-banner">
        <span className="sr-only" role="img" aria-label="Admin Forgot Password Page"></span>
        <div className="container">
          <div className="row justify-content-center align-items-center authentication authentication-basic h-100">
            <div className="col-xxl-5 col-xl-5 col-lg-5 col-md-6 col-sm-8 col-12">
              <div className="admin-login-container custom-card my-4">
                <div className="card-body p-5">
                  <div className="mb-3 d-flex justify-content-center">
                    <img
                      className="Sidebarlogo"
                      src={Logo}
                      alt="small-logo"
                    ></img>
                  </div>

                  <form
                    onSubmit={(e) => {
                      handleSubmit(e);
                    }}
                  >
                    <h2 className="title-default mb-2">
                      Forgot <span id="forgetTitle"> Password?</span>
                    </h2>
                    <p className="font-size-16">
                      Enter the email you used to sign up for your BPK account.
                      We'll send you a link to reset your password.
                    </p>
                    <div className="mb-3">
                      <TextInput
                        name="email"
                        label="Email Address"
                        value={email}
                        handleChange={(e) => {
                          handleForgotPasswordEmail(e);
                          // setEmail(e?.target?.value);
                        }}
                        ariaLabel="Email Address"
                        placeholder="Email Address"
                        required={true}
                        errorMessage={errorMessage}
                      //    handleBlur={handleBlur}    // temporarly Commented
                      />
                    </div>
                    <div className="mb-4">
                      <Button
                        className={"me-2"}
                        label="Submit"
                        type="submit"
                        status="primary"
                        disabled={submit}
                      />
                      <Button
                        className="me-2 "
                        label="Reset"
                        type="reset"
                        variant="danger"
                        status={"secondary"}
                        disabled={false}
                        onClick={handleReset}
                      />
                      {/* Back to Login Text */}

                      <span
                        className="font-size-15 d-block mt-3 mb-40px pb-40px " // Using Bootstrap's "danger" color
                      >
                        Back to{" "}
                        <b
                          className="txt-primary text-underline font-size-15"
                          onClick={handleClickLogin}
                          style={{ cursor: "pointer" }}
                          tabindex="0"
                        >
                          {" "}
                          Login
                        </b>
                      </span>
                    </div>
                    <hr className="bg-gray-600 opacity-2 " />
                    <p className="text-center text-gray-600">
                      &copy; BPK All Right Reserved {new Date().getFullYear()}
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminForgotPassword;
